import React from 'react'
import { Link } from 'react-router-dom';

function Shippingservices() {
  return (
     <div>
  {/* Hero Section */}
  <div
           className="relative w-full h-screen bg-cover bg-center flex items-center justify-center text-white"
           style={{ backgroundImage: "url('/images/shipping1.jpeg')" }}
         >
           <div className="absolute inset-0 bg-black bg-opacity-50"></div>
           <div className="relative text-center px-6">
           <h1 className="text-5xl md:text-8xl font-semibold ">Shipping Services</h1>
<p className="mt-4 text-lg md:text-2xl text-gray-200 max-w-4xl mx-auto">
   Secure and cost-effective sea freight solutions connecting the World. We ensure smooth and timely transportation of goods across global ocean routes.
</p>

             <a
               href="/contactus"
               className="mt-6 inline-block bg-white hover:bg-gray-200 text-black px-6 py-2 md:py-3 text-lg font-semibold  transition"
             >
               Get a Free Quote
             </a>
           </div>
         </div>
         <h1 className=" text-4xl md:text-5xl lg:text-6xl text-black text-center mt-12 font-thin lg:p-4">Reliable Shipping Solutions Worldwide</h1>
 
 
      {/* <TransportCards/> */}
      <div className="flex flex-col lg:flex-row items-center p-3 md:p-4 justify-center space-y-6 md:space-y-0 lg:gap-20 xl:gap-40 mt-12 lg:mt-12 xl:mt-32">
           <div className="lg:w-1/2 2xl:w-1/3 flex justify-center">
             <img 
               src="images/shippingcase1.jpg" 
               alt="Freight Platform" 
               className="w-full h-[250px] md:h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
             />
           </div>
           <div className="lg:w-1/2 2xl:w-1/3 text-center lg:text-left space-y-4 md:text-lg ">
           <p className="text-2xl md:text-4xl font-thin text-center text-gray-800 mt-6">
           Efficient & Affordable Sea Freight Solutions.
    </p>
    <p className=" text-xl  md:text-2xl   text-justify font-thin md:leading-relaxed text-gray-600">
    Leverage our global contract rates with leading shipping lines worldwide. With advanced visibility, SKU-level insights, seamless collaboration, real-time milestone tracking,
     and automated exception monitoring, your shipments stay on course without missing a wave.
    </p>
           </div>
         </div>
   
         <div className="flex flex-col lg:flex-row items-center p-3 md:p-8 justify-center space-y-6 md:space-y-0 md:gap-20 xl:gap-40 lg:mt-12 xl:mt-32">
         <div className="lg:w-1/2 2xl:w-1/3  md:hidden flex justify-center">
             <img 
               src="images/shippingcase2.jpg" 
               alt="Freight Platform" 
               className="w-full h-[250px] md:h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
             />
           </div>
           <div className="lg:w-1/2 2xl:w-1/3 text-center md:text-left space-y-4 md:text-lg">
    <p className="text-2xl md:text-4xl font-thin text-center text-gray-800">
        Simplified Sea Freight Solutions for Seamless Global Shipping
    </p>
    <p className="text-xl md:text-2xl text-justify font-thin leading-relaxed text-gray-600">
        Plan and manage your shipments effortlessly with real-time sailing schedules, online booking, and full track & trace capabilities. 
        Our services include import/export consolidation, deconsolidation, flexible shipping options, project cargo handling, 
        and in-house customs clearance—ensuring smooth and cost-effective freight movement across global ocean routes.
    </p>
</div>

           <div className=" hidden lg:w-1/2 2xl:w-1/3 md:flex justify-center">
             <img 
               src="images/shippingcase2.jpg" 
               alt="Freight Platform" 
               className="w-full h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
             />
           </div>
         </div>
   
   
         <div className="flex flex-col lg:flex-row items-center p-4 md:p-8 justify-center space-y-6 md:space-y-0 md:gap-20 xl:gap-40 lg:mt-12 xl:mt-32">
           <div className="lg:w-1/2 2xl:w-1/3 flex justify-center">
             <img 
               src="images/shippingcase.jpg" 
               alt="Freight Platform" 
               className="w-full h-[250px] md:h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
             />
           </div>
           <div className="lg:w-1/2 2xl:w-1/3 text-center md:text-left space-y-4 md:text-lg">
           <p className="text-2xl md:text-4xl text-center font-thin text-gray-800">
    Reliable Weekly LCL & FCL Import & Export Services
</p>
<p className="text-xl md:text-2xl text-justify font-thin leading-relaxed text-gray-600">
    Leverage our decades of expertise in ocean freight solutions tailored to fit any budget and transit time needs. 
    With strong partnerships and extensive buying power, we provide seamless access to global destinations, 
    ensuring competitive rates and dependable shipping services for your cargo.
</p>

             {/* <div className='flex justify-center pt-4'>
             <Link to='/contactus'>
               <button className="bg-slate-800 text-white px-6 py-2 rounded-xl hover:bg-slate-600 transition-colors duration-300">
                 Schedule a Demo
               </button></Link>
             </div> */}
           </div>
         </div>
   
         <div className="flex flex-col lg:flex-row items-center p-3 md:p-8 justify-center space-y-6 md:space-y-0 md:gap-20 xl:gap-40 lg:mt-12 xl:mt-32">
         <div className="md:hidden flex justify-center">
             <img 
               src="images/shiptracking.jpg" 
               alt="Freight Platform" 
               className="w-full h-[250px] md:h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
             />
           </div>
           <div className="lg:w-1/2 2xl:w-1/3 text-center md:text-left space-y-4 md:text-lg">
           <p className=" text-center text-2xl md:text-4xl font-thin text-gray-800">
    Seamless Shipment Tracking   
</p>
<p className="text-xl md:text-2xl text-justify font-thin leading-relaxed text-gray-600">
    Track and manage your shipments effortlessly. 
    Gain end-to-end visibility with deep connectivity and SKU-level insights, ensuring complete control over your POs from origin to destination. 
    Stay informed with real-time updates on any disruptions or schedule changes, keeping your operations running smoothly.  
</p>


           </div>
           <div className="lg:w-1/2  2xl:w-1/3 hidden md:flex justify-center">
             <img 
               src="images/shiptracking.jpg" 
               alt="Freight Platform" 
               className="w-full h-auto max-w-xs md:max-w-full rounded-3xl transition-transform duration-300 ease-in-out transform hover:scale-105"
             />
           </div>
         </div>

         <section className="relative  bg-cover bg-center  bg-no-repeat w-full  py-36 mt-20" style={{ backgroundImage: "url('images/conbg4.png') " }}>
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="relative z-10 container mx-auto text-center text-white px-6">
          <h2 className="text-3xl md:text-[45px] mb-6 font-thin">For more information on our Shipping services, please reach out to us</h2>
            <div className=" flex justify-center">
            </div>
          
            <a
              href="/contactus"
              className="inline-block bg-gray-200 text-black  px-8 py-2 md:py-3 uppercase shadow-lg hover:bg-slate-800 hover:text-white transition duration-300"
            >
              Contact Us
            </a>
          </div>
        </section>
     </div>
 
 
   );
 };
 

export default Shippingservices

// import React from "react";

// function ShippingServices() {
//   return (
//     <div className="bg-gray-100">
//       {/* Hero Section */}
//       <div className="relative w-full h-[400px] bg-cover bg-center flex items-center justify-center" style={{ backgroundImage: "url('/images/world-map.jpg')" }}>
//         <div className="bg-black bg-opacity-50 p-6 text-white text-center rounded-lg">
//           <h1 className="text-4xl font-bold mb-2">International Shipping Services</h1>
//           <p className="text-lg">Reliable & Fast Shipping to Dubai, Canada, India, UK, and America.</p>
//         </div>
//       </div>

//       {/* Services Section */}
//       <div className="container mx-auto px-6 py-12">
//         <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">Our Shipping Destinations</h2>
//         <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {[
//             { country: "Dubai", image: "/images/dubai.jpg" },
//             { country: "Canada", image: "/images/canada.jpg" },
//             { country: "India", image: "/images/india.jpg" },
//             { country: "UK", image: "/images/uk.jpg" },
//             { country: "America", image: "/images/usa.jpg" },
//           ].map((item, index) => (
//             <div key={index} className="bg-white shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:scale-105">
//               <img src={item.image} alt={item.country} className="w-full h-48 object-cover" />
//               <div className="p-4">
//                 <h3 className="text-xl font-semibold">{item.country}</h3>
//                 <p className="text-gray-600 mt-2">
//                   We offer fast and affordable shipping to {item.country}, ensuring your packages arrive on time.
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Why Choose Us */}
//       <div className="bg-slate-600 text-white py-12">
//         <div className="container mx-auto text-center">
//           <h2 className="text-3xl font-bold">Why Choose Our Shipping Services?</h2>
//           <p className="mt-4 text-lg">We ensure secure, on-time, and cost-effective international shipping.</p>
//           <div className="grid md:grid-cols-3 gap-6 mt-8 text-left">
//             {[
//               "Fast & Reliable Delivery",
//               "Secure Packaging",
//               "Real-time Tracking",
//               "Affordable Pricing",
//               "Customs Clearance Assistance",
//               "24/7 Customer Support",
//             ].map((feature, index) => (
//               <div key={index} className="bg-white text-slate-600 p-6 rounded-lg shadow-md">
//                 <p className="font-semibold">{feature}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Call to Action */}
//       <div className="text-center py-12">
//         <h3 className="text-2xl font-bold">Get a Free Shipping Quote Today!</h3>
//         <p className="text-gray-600 mt-2">Contact us for customized shipping solutions.</p>
//         <button className="mt-4 px-6 py-3 bg-gradient-to-r from-gray-500 to-gray-600 text-white font-semibold rounded-lg shadow-lg hover:scale-105 transition-transform">
//           Contact Us
//         </button>
//       </div>
//     </div>
//   );
// }

// export default ShippingServices;
